<template>
	<div class="h-full">
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex h-full flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
/**
 * 구매하기 메인 컴포넌트(sales main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

export default {
	name: 'sales',

	components: {
		TopAppBar,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin]
}
</script>
